export default "__VITE_ASSET__DPCEiwN3__"